import type { AgentsCounts } from '@fos/shared/contracts/agents';
import type { NavBadges } from '../../lib/nav-badges';

/**
 * Plakietka „Agenci” w menu (kompozycja Fali 5, DESIGN §5): „Muted” — liczba moich wyników AI do odbioru
 * (`agents.counts`). Spokojna, szara: informuje, nie wzywa (decyzje są w Akceptacjach).
 */
export async function agentsNavBadges(fetchCounts: () => Promise<AgentsCounts>): Promise<NavBadges> {
  const counts = await fetchCounts();
  return counts.toReview > 0 ? { agents: { kind: 'muted', count: counts.toReview } } : {};
}
